export default {
	'particles': {
		'number': {
			'value': 100,
			'density': {
				'enable': true,
				'value_area': 500
			}
		},
		'color': {
			'value': ['#FFFFFF', '#322D4E', '#5A6472', '#5A6472']
		},
		'shape': {
			'type': 'circle',
			'stroke': {
				'width': 0,
				'color': '#000000'
			},
			'polygon': {
				'nb_sides': 4,
			},
		},
		'opacity': {
			'value': 0.3,
			'random': false,
			'anim': {
				'enable': false,
				'speed': 5,
				'opacity_min': 0.1,
				'sync': true
			}
		},
		'size': {
			'value': 5,
			'random': true,
			'anim': {
				'enable': false,
				'speed': 40,
				'size_min': 0.1,
				'sync': false
			}
		},
		'line_linked': {
			'enable': true,
			'distance': 200,
			'color': '#ffffff',
			'opacity': 0.3,
			'width': 1,
		},
		'move': {
			'enable': true,
			'speed': 0.85,
			'direction': 'none',
			'random': false,
			'straight': false,
			'out_mode': 'out',
			'bounce': false,
			'attract': {
				'enable': false,
				'rotateX': 600,
				'rotateY': 1200
			}
		}
	},
	'retina_detect': true
};
